/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Col_WhoInputs */

const cs_gdpr_col_who = /** @type {(inputs: Gdpr_Col_WhoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kdo`)
};

const en_gdpr_col_who = /** @type {(inputs: Gdpr_Col_WhoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who`)
};

/**
* | output |
* | --- |
* | "Who" |
*
* @param {Gdpr_Col_WhoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_col_who = /** @type {((inputs?: Gdpr_Col_WhoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Col_WhoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_col_who(inputs)
	return cs_gdpr_col_who(inputs)
});